import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import PointsHistoryLayout from "./components/layout/index";
import { renderRoutes } from "react-router-config";

export default ({route}) =>{
    useStyles(cls);

    return <PointsHistoryLayout>
        {renderRoutes(route.routes)}
    </PointsHistoryLayout>
}